import { render, staticRenderFns } from "./FormatarMoeda.vue?vue&type=template&id=0ffcc97a&scoped=true"
import script from "./FormatarMoeda.vue?vue&type=script&setup=true&lang=js"
export * from "./FormatarMoeda.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormatarMoeda.vue?vue&type=style&index=0&id=0ffcc97a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffcc97a",
  null
  
)

export default component.exports